"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var react_acdc_1 = require("@seaweb/react-acdc");
var useForkRef_1 = __importDefault(require("@seaweb/coral/hooks/useForkRef"));
var TextField_1 = __importDefault(require("@seaweb/coral/components/TextField/TextField"));
var Popper_1 = require("@seaweb/coral/components/Popper");
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var forwardAs_1 = __importDefault(require("@seaweb/coral/hoc/forwardAs"));
var SelectArrowIcon_1 = __importDefault(require("./SelectArrowIcon"));
var SelectSelectedContent_1 = __importDefault(require("./SelectSelectedContent"));
var SelectContext_1 = require("./SelectContext");
var SelectedContentWrapper = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 85%;\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n  transition: opacity 0.1s ease;\n\n  ", "\n\n  ", "\n"], ["\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 85%;\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n  transition: opacity 0.1s ease;\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0 ", "px;\n    font-size: ", "px;\n    font-family: ", ";\n  "], ["\n    padding: 0 ", "px;\n    font-size: ", "px;\n    font-family: ", ";\n  "])), 3.5 * theme.spacing.factor, theme.typography.sizes.main, theme.typography.main);
}, function (_a) {
    var fade = _a.fade;
    return fade
        ? styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          opacity: 0.5;\n        "], ["\n          opacity: 0.5;\n        "]))) : styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          ~ input {\n            color: transparent;\n          }\n        "], ["\n          ~ input {\n            color: transparent;\n          }\n        "])));
});
var WrappedTextField = forwardAs_1.default(TextField_1.default, ['isOpen']);
var StyledTextField = styled_1.default(WrappedTextField)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var isOpen = _a.isOpen, _b = _a.theme, spacing = _b.spacing, colors = _b.colors;
    return styled_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-right: ", "px;\n\n    ", "\n  "], ["\n    padding-right: ", "px;\n\n    ",
        "\n  "])), spacing.factor * 8, isOpen && styled_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      border-color: ", ";\n      background-color: ", ";\n    "], ["\n      border-color: ", ";\n      background-color: ", ";\n    "])), colors.primary, colors.plain));
});
var SelectSearch = react_1.forwardRef(function SelectSearch(_a, ref) {
    var _b = _a.spellCheck, spellCheck = _b === void 0 ? false : _b, _c = _a.rightElement, rightElement = _c === void 0 ? react_1.default.createElement(SelectArrowIcon_1.default, null) : _c, leftElement = _a.leftElement, placeholder = _a.placeholder, children = _a.children, disabled = _a.disabled, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur, onChange = _a.onChange, onKeyDown = _a.onKeyDown, props = __rest(_a, ["spellCheck", "rightElement", "leftElement", "placeholder", "children", "disabled", "onClick", "onFocus", "onBlur", "onChange", "onKeyDown"]);
    var isOpen = react_acdc_1.useAcdcContext().state.isOpen;
    var _d = __read(react_acdc_1.useAcdcInputProps(), 1), _e = _d[0], inpRef = _e.ref, value = _e.value, alb = _e["aria-labelledby"], acdcClick = _e.onClick, acdcFocus = _e.onFocus, acdcBlur = _e.onBlur, acdcChange = _e.onChange, acdcKeyDown = _e.onKeyDown, inputProps = __rest(_e, ["ref", "value", 'aria-labelledby', "onClick", "onFocus", "onBlur", "onChange", "onKeyDown"]);
    var _f = __read(react_1.useState(false), 2), focused = _f[0], setFocused = _f[1];
    var handleFocus = useWrapEvent_1.default(useWrapEvent_1.default(onFocus, acdcFocus), function () { return setFocused(true); });
    var handleBlur = useWrapEvent_1.default(useWrapEvent_1.default(onBlur, acdcBlur), function () { return setFocused(false); });
    var handleClick = useWrapEvent_1.default(onClick, acdcClick);
    var handleChange = useWrapEvent_1.default(onChange, acdcChange);
    var handleKeyDown = useWrapEvent_1.default(onKeyDown, acdcKeyDown);
    var inputRef = inpRef;
    var referenceRef = Popper_1.usePopperReference().ref;
    var handleRef = useForkRef_1.default(ref, useForkRef_1.default(inputRef, referenceRef));
    var justSelect = SelectContext_1.useSelectContext().justSelect;
    var contentFade = !justSelect && focused;
    return (react_1.default.createElement(StyledTextField, __assign({ isOpen: isOpen, spellCheck: spellCheck, disabled: disabled, ref: handleRef, rightElement: rightElement, value: value, onClick: handleClick, onFocus: handleFocus, onBlur: handleBlur, onChange: handleChange, onKeyDown: handleKeyDown }, inputProps, props), !value && (react_1.default.createElement(SelectedContentWrapper, { fade: contentFade, "data-coral-select-selected-content-wrapper": "" },
        react_1.default.createElement(SelectSelectedContent_1.default, { placeholder: placeholder, disabled: disabled }, children)))));
});
exports.default = react_1.memo(SelectSearch);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
